import { NestedKeyOf } from 'next-intl';
import { getTranslations } from 'next-intl/server';
import { IntlMessagesKeys } from '@headless-workspace/typings';
import { RichText } from '../../../client';
import { AsyncComponent } from '../types';

const FOOTER_ADDITIONAL_MENTIONS_MAX_LENGTH = 6;
const FOOTER_ADDITIONAL_MENTIONS_KEY = 'Footer.additionalMentions';

export const FooterAdditionalMentions: AsyncComponent = async () => {
    const t = await getTranslations(FOOTER_ADDITIONAL_MENTIONS_KEY);

    const mentions = [];
    for (let i = 0; i < FOOTER_ADDITIONAL_MENTIONS_MAX_LENGTH; i++) {
        const mentionIndex = i + 1;
        const messageKey = `${FOOTER_ADDITIONAL_MENTIONS_KEY}.line${mentionIndex}.text` as IntlMessagesKeys;
        const linkHref = t(`line${mentionIndex}.link` as NestedKeyOf<IntlMessagesKeys>);

        mentions.push(
            <RichText
                key={`additional-mention-${mentionIndex}`}
                messageKey={messageKey}
                fontSize="caption"
                color="secondary-inverse-fixed"
                links={{
                    link: {
                        href: linkHref,
                    },
                }}
            />,
        );
    }

    return (
        <section>
            <h3 className={'sr-only'}>{t('title')}</h3>
            {mentions}
        </section>
    );
};
